'use client';

import Image from 'next/image';
import style from './style.module.css';
import { BackToHome } from './back-to-home';
import { useEffect } from 'react';
import { addDDError } from '@wwe-portal/web/libs/analytics/datadog';

export function NotFoundUI() {
  useEffect(() => {
    addDDError('404-visit-count');
  }, []);
  return (
    <div className="relative inset-x-0 h-[100vh] overflow-hidden xl:ml-[240px] xl:mr-[280px]">
      <div className="absolute flex h-full w-full flex-col items-center justify-between pb-[90px] pt-[75px]">
        <div>
          <Image
            className="inset-x-0 m-auto w-[150px] md:w-[200px]"
            src="/assets/images/common/wwe-champions-logo-main.webp"
            alt="logo"
            width={200}
            height={123}
          />
        </div>

        <div className="flex w-full flex-col items-center justify-center md:inset-x-0 md:bottom-0">
          <div className={style.title}>Page Not Found, Brother!</div>
          <div className="flex items-center justify-center">
            <BackToHome />
          </div>
        </div>
      </div>

      <Image
        src="/assets/images/404/404-Responsive.webp"
        alt="logo"
        width={0}
        height={0}
        sizes="100vw"
        className="block h-full max-h-full w-full max-w-full object-contain object-center md:hidden"
      />
      <Image
        src="/assets/images/404/404-new.webp"
        alt="logo"
        width={0}
        height={0}
        sizes="100vw"
        className="hidden h-full max-h-full w-full max-w-full object-contain object-top md:block"
      />
    </div>
  );
}
